__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-02-02-1770034708-stable-dev/";